import { render, staticRenderFns } from "./xmfzrDetail.vue?vue&type=template&id=14655ffd&scoped=true"
import script from "./xmfzrDetail.vue?vue&type=script&lang=js"
export * from "./xmfzrDetail.vue?vue&type=script&lang=js"
import style0 from "./xmfzrDetail.vue?vue&type=style&index=0&id=14655ffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14655ffd",
  null
  
)

export default component.exports